import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";

export class EventInterruptionForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            event: this.parsePropsEvent(props.event),
            beginDateInputError: null,
            endDateInputError: null,
            calendarInputError: null,
        }
    }

    parsePropsEvent(event) {
        if(undefined === event || null === event) {
            return undefined;
        }

        return {
            id: event.id,
            beginDate: new Date().toISOString().split("T")[0],
            endDate: event.endDate,
            dayType: undefined,
            calendar: undefined
        };
    }

    // -----------------

    onChangeValue(e, property) {
        const { event } = this.state;

        event[property] = e.target.value;

        this.setState({
            event: event
        });
    }

    onChangeDateValue(e, property) {
        const { event } = this.state;

        if (null === e || undefined === e) {
            event[property] = undefined;
        }
        else {
            event[property] = e.split("T")[0];
        }

        this.setState({
            event: event
        });
    }

    onSelectValue(e, property) {
        const { event } = this.state;

        event[property] = e;

        this.setState({
            event: event
        });
    }

    onSave() {
        if (this.validInput()) {
            const { event } = this.state;
            this.props.onSave(event);
        }
    }

    validInput() {
        let errors = 0;
        let beginDateInputError = null;
        let endDateInputError = null;
        let calendarInputError = null;

        const { event } = this.state;

        if ("" === event.beginDate || null === event.beginDate || undefined === event.beginDate) {
            beginDateInputError = 'error';
            errors++;
        }

        if ("" !== event.endDate && null !== event.endDate && undefined !== event.endDate && event.endDate < event.beginDate) {
            endDateInputError = 'error';
            errors++;
        }

        if (null === event.calendar || undefined === event.calendar) {
            calendarInputError = 'error';
            errors++;
        }

        this.setState({
            beginDateInputError: beginDateInputError,
            endDateInputError: endDateInputError,
            calendarInputError: calendarInputError,
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { event, beginDateInputError, endDateInputError, calendarInputError } = this.state;
        const { calendars } = this.props;

        if (undefined === event || null === event) {
            return null;
        }

        const { title } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formCalendar" validationState={calendarInputError}>
                            <ControlLabel>Calendário</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Calendário"
                                noOptionsMessage={() => "Sem Tipos de Dia Configurados"}
                                onChange={(e) => this.onSelectValue(e, "calendar")}
                                options={calendars}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== event.calendar && undefined !== event.calendar) {
                                        return event.calendar.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={event.calendar}
                            />
                            {calendarInputError !== null ?
                                <HelpBlock> Calendário inválido.</HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formBeginDate" validationState={beginDateInputError}>
                            <ControlLabel>Data de Início</ControlLabel>
                            <DatePicker
                                id="beginDatePicker"
                                dateFormat="YYYY/MM/DD"
                                value={event.beginDate}
                                placeholder="Introduza a Data de Início"
                                onChange={(e) => this.onChangeDateValue(e, 'beginDate')} />

                            {beginDateInputError !== null ?
                                <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                            <ControlLabel>Data de Fim</ControlLabel>
                            <DatePicker
                                id="endDatePicker"
                                dateFormat="YYYY/MM/DD"
                                value={event.endDate}
                                placeholder="Introduza a Data de Fim"
                                onChange={(e) => this.onChangeDateValue(e, 'endDate')} />

                            {endDateInputError !== null ?
                                <HelpBlock> Valor de data inválido. Verifique que a data não é anterior à data inicial e que não está vazia. </HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
